import React from "react"
import {
    Text,
    View,
    StyleSheet,
} from "react-native"

// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from '@expo/vector-icons';
import Colors from "../../constants/Colors";
import FontStyles from "../../constants/FontStyle";

const colors = {
    delivered: {
        icon: 'md-checkmark-circle',
        color: '#00A879'
    },
    pending: {
        icon: 'ios-time',
        color: '#F9B13D'
    },
    cancelled: {
        icon: 'md-close-circle',
        color: '#EE3939'
    }
}

const OrderStatus = (props) => {
    let output = null
    let tag = props?.type

    if (['delivered', 'completed'].includes(tag)) {
        tag = 'success'
    }
    if (['deleted', 'cancelled'].includes(tag)) {
        tag = 'error'
    }

    switch (tag) {
        case 'success':
            output = (
                <View style={styles.statusContainer}>
                    <View style={[styles.statusIconContainer]}><Icon name={colors.delivered.icon} color={colors.delivered.color} size={14} /></View>
                    <Text style={[styles.statusText, { color: colors.delivered.color }]}>Delivered</Text>
                </View>
            )
            break;

        case 'error':
            output = (
                <View style={styles.statusContainer}>
                    <View style={[styles.statusIconContainer]}><Icon name={colors.cancelled.icon} color={colors.cancelled.color} size={14} /></View>
                    <Text style={[styles.statusText, { color: colors.cancelled.color }]}>Cancelled</Text>
                </View>
            )
            break;

        default:
            // pending
            output = (
                <View style={styles.statusContainer}>
                    <View style={[styles.statusIconContainer]}><Icon name={colors.pending.icon} color={colors.pending.color} size={14} /></View>
                    <Text style={[styles.statusText, { color: colors.pending.color }]}>Pending</Text>
                </View>
            )
            break;
    }

    return output
}

const styles = StyleSheet.create({
    statusContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    statusIconContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 5,
    },
    statusText: {
        ...FontStyles.normal,
        ...FontStyles.size13,
        ...FontStyles.lh16,
    }
})

export default OrderStatus